import "../styles/navbar.scss";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import burgerIcon from "../misc/logos/burger-bar.png";
import closeIcon from "../misc/logos/close.png";
import { logos } from "../services/data.ts";
import { WhatsappBurger } from './whatsapp';
import { LogoMini } from "./logo.jsx";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const burgerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle "O Relojoeiro" click
  const linkClick = (id) => {
    
    if (location.pathname !== `/${id}`) {
      navigate(`/${id}`);
    }
  };

  // Toggle burger menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both menu and burger button
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          burgerRef.current && !burgerRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    // Add event listener when menu is open
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Scroll to section or top of the page
  const scrollToSection = (id) => {
    if (id === 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      } else {
        console.error(`Section with id "${id}" not found.`);
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <nav>
      <LogoMini />
      <a href="/"><img src={logos.nome_b_por} id="name-logo" /></a>
      
      {/* Burger Menu Icon - Added ref here */}
      <div className="burger-menu" onClick={toggleMenu} ref={burgerRef}>
        <img
          src={isMenuOpen ? closeIcon : burgerIcon}
          alt={isMenuOpen ? "Close Menu" : "Open Menu"}
          className="menu-icon"
        />
      </div>

      {/* Navigation Links - Added ref here */}
      <ul ref={menuRef} className={`nav-links ${isMenuOpen ? "open" : "closed"}`}>
        {isMenuOpen ?
          <a href="/">
            <img src={logos.nome_b_por} id="name-logo" />
          </a>
          : ''
        }
        <li className="link" onClick={() => {
          linkClick("historia");
          setIsMenuOpen(false)
        }
          }>O Relojoeiro</li>
        <li className="link" onClick={() => {
          linkClick("etapas")
          setIsMenuOpen(false)
          }}>Etapas</li>
          
 {
  window.location.pathname === "/" ? (
    <li className="link" onClick={() => {  
          scrollToSection("services")
          setIsMenuOpen(false)
          }}>Serviços</li>
  ) : (
    <a className="link"  href="/" onClick={() => {  
    setIsMenuOpen(false)
    }}>Serviços</a>
  )
}
        <li className="link" onClick={() => {
          scrollToSection("contact")
          setIsMenuOpen(false)
          }}>Contato</li>
        <WhatsappBurger />
      </ul>
    </nav>
  );
};

export default Navbar;